import React from "react";
import { twMerge } from "tailwind-merge";

export default function Container({
  direction = "col",
  p = 6,
  gap = 6,
  ...props
}) {
  return (
    <div
      {...props}
      className={twMerge(
        `overflow-y-auto relative max-w-7xl lg:max-h-[760px] w-full flex flex-${direction} p-${p} gap-${gap}`,
        props.className
      )}
    />
  );
}
